import { environment } from '../../environments/environment';
import { RealtimeInterface } from '../services/realtime/realtime-interface';
import { PlanningHasEntity } from './planning-has-entity.class';
import { ProjectComment } from './project-comment';
import { UserPlanning } from './user-planning';
import { User } from './user.class';

export class Project implements RealtimeInterface {
    afas_project_id: string;
    afas_customer_id: string;
    parent_id: string;
    parent?: Project;
    id: number;
    name: string;
    group: string;
    projectmanager_id: number;
    performer_id: number;
    performer: User;
    projectmanager: User;
    asphalt_performer_id: number;
    asphalt_performer: User;
    location: string;
    location_housenumber: string;
    location_place: string;
    location_postcode: string;
    location_straat: string;
    contractor: string;
    begindate: Date;
    enddate: Date;
    created_at: Date;
    updated_at: Date;

    status: number;
    status_name: string;

    user_planning: UserPlanning[];
    planning_has: PlanningHasEntity[];
    project_comments: ProjectComment[];
    realisation_times?: {
        week: number;
        year: number;
        user_minutes: number;
        entity_minutes: number;
    }[];

    mainProject?: string;
    projects?: Project[];

    week_numbers?: string;
}

/**
 * Een hoofdproject verwijst sinds de AFAS-import naar zichzelf (parent_id == afas_project_id),
 * oudere rijen hebben parent_id leeg. Gebruik deze helpers overal in plaats van een
 * truthiness-check op parent_id, want die herkent de self-reference niet.
 */
export const isSubProject = (project: Project): boolean =>
    !!project?.parent_id && project.parent_id !== project.afas_project_id;

export const isMainProject = (project: Project): boolean => !isSubProject(project);

/** Projects that can be selected (planning, hours): deelprojecten, or hoofdprojecten on platforms without deelprojecten. */
export const isSelectableProject = (project: Project): boolean =>
    environment.subProjects ? isSubProject(project) : isMainProject(project);

export enum ProjectStatus {
    Hoofdproject = 0,
    Offerte = 1,
    Opdracht = 2,
    TechnGereed = 3,
    FinGereed = 4,
    Vervallen = 5,
    Afgesloten2023 = 823,
    Afgesloten2024 = 824,
    Afgesloten2025 = 825,
    Afgemeld = 900,
}
